import {Component, input, Input} from '@angular/core';
import {getEscalationStatus} from "../../../escalation/escalation.model";
import {getTimeZoneString} from "../../../../shared/helpers/dateTime/getTimeZoneString";
import {ViewModel} from "../../../report/report.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-report-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent {
  vm = input<ViewModel>();
  @Input() downtime: string;

  protected readonly getEscalationStatus = getEscalationStatus;
  protected readonly getTimeZoneString = getTimeZoneString;
}
